export default "__VITE_ASSET__Dm_bXH11__"